exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);

// module
exports.push([module.id, ".download-confirmation-link {\n  color: #8b3187;\n  text-decoration: underline;\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/DownloadConfirmationLink/DownloadConfirmationLink.scss
// module id = 1649
// module chunks = 0